import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, MANAGEMENT_APPLICATIONS_ROLES } from '@aacr/shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'AACR Management';

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  get canAccessApplications(): boolean {
    return this.isAuthenticated && this.authService.hasAnyRole(MANAGEMENT_APPLICATIONS_ROLES);
  }

  logout(): void {
    if (!this.authService.logout()) {
      this.router.navigate(['/login']);
    }
  }
}
